import { message } from 'antd'
import React from 'react'

import { ProjectWorkResourceInput } from '@/components/work-resource/special-project/special-project-work-resource.container'
import {
  ProjectTableColumnKey,
  ProjectTableColumnKeyMap,
} from '@/components/work-resource/special-project/special-project-work-resource.util'
import { ProjectStatus } from '@/schemas'

export const getIsColumnRequired = (key: ProjectTableColumnKey, status?: ProjectStatus) => {
  if (status === undefined) return false
  switch (status) {
    case ProjectStatus.未开始: {
      switch (key) {
        case ProjectTableColumnKey.Department:
        case ProjectTableColumnKey.Period: {
          return true
        }
      }
      return false
    }
    default: {
      if (key === ProjectTableColumnKey.WeekWorkload || key === ProjectTableColumnKey.PredictWorkload) {
        return false
      }
      return true
    }
  }
}

export function validateFields(
  data: Partial<ProjectWorkResourceInput>,
  getIsColumnRequired: (key: ProjectTableColumnKey, status?: ProjectStatus) => boolean,
  status?: ProjectStatus
) {
  let invalidField
  const keys = Object.keys(data) as (keyof ProjectWorkResourceInput)[]
  for (const key of keys) {
    switch (key) {
      case 'departmentId': {
        const shouldValidate = getIsColumnRequired(ProjectTableColumnKey.Department, status)
        if (shouldValidate && (!data.departmentId || !data.departmentName)) {
          invalidField = ProjectTableColumnKey.Department
        }
        break
      }
      case 'email': {
        const shouldValidate = getIsColumnRequired(ProjectTableColumnKey.Email, status)
        if (shouldValidate && !data.email) {
          invalidField = ProjectTableColumnKey.Email
        }
        break
      }
      // case 'predictWorkload': {
      //   const shouldValidate = getIsColumnRequired(ProjectTableColumnKey.PredictWorkload, status)
      //   if (shouldValidate && !data.predictWorkload) {
      //     invalidField = ProjectTableColumnKey.PredictWorkload
      //   }
      //   break
      // }
      case 'startDate':
      case 'endDate': {
        if (!data.startDate || !data.endDate) {
          invalidField = ProjectTableColumnKey.Period
        }
        break
      }
    }

    if (invalidField) {
      message.warn(
        <span>
          字段<span style={{ fontWeight: 'bold', margin: '0 8px' }}>{ProjectTableColumnKeyMap[invalidField]}</span>
          是必填项，请完成填写
        </span>
      )
      return false
    }
  }
  return true
}
